import { CheckCircleOutlined, CloseCircleOutlined } from '@ant-design/icons';
import { Button, Modal } from 'antd';
import { Link, useParams } from 'react-router-dom';
import { Utility } from '../../utilities/Utility';

const ConfirmationModal = ({
    isOpen,
    onClose,
    isSuccess = true,
    title,
    message,
    primaryButtonText,
    secondaryButtonText,
    onPrimaryButtonLinkTo = ``,
    onSecondaryButtonLinkTo = ``,
    onPrimaryButtonLinkToClick,
    onSecondaryButtonLinkClick,
}: {
    isOpen: boolean;
    onClose: () => void;
    isSuccess?: boolean;
    title: string;
    message: string;
    primaryButtonText: string;
    secondaryButtonText: string;
    onPrimaryButtonLinkTo?: string;
    onSecondaryButtonLinkTo?: string;
    onPrimaryButtonLinkToClick?: () => void;
    onSecondaryButtonLinkClick?: () => void;
}) => {
    const { id: patientId = '' } = useParams();

    return (
        <Modal
            open={isOpen}
            onCancel={onClose}
            footer={null}
            closable={false}
            className="confirmation-order"
            style={{ top: '50%', translate: '0 -50%' }}
        >
            <div className="d-flex gap-2 flex-column align-items-center justify-content-center p-3">
                {!isSuccess ? 
                    <CloseCircleOutlined 
                        rev={undefined}
                        className="text-light-red"
                        style={{ fontSize: '6em' }}
                    />
                    :
                    <CheckCircleOutlined
                        rev={undefined}
                        className="text-light-blue"
                        style={{ fontSize: '6em' }}
                    />
                }

                <div className="d-flex gap-1 flex-column align-items-center">
                    <h4 className={`m-0 ${isSuccess ? 'text-medium-blue' : 'text-light-red'}`}>{title}</h4>
                    <span className="fs-6 text-pre-wrap text-center mb-3">
                        {message.split("\n").map((line) => (
                            <p className='p-0 m-0'>{line}</p>
                        ))}
                    </span>
                    <Button
                        color="default"
                        shape="round"
                        className="py-2 px-5 bg-light-blue text-white fw-semibold fs-6 border-0"
                        style={{ height: 'auto' }}
                    >
                        {/* Allows to handle custom functions and simple navigations */}
                        {!Utility.isNullOrUndefinedOrEmpty(onPrimaryButtonLinkTo) ? (
                            <Link to={onPrimaryButtonLinkTo} className="text-decoration-none">
                                {primaryButtonText}
                            </Link>
                        ) : (
                            <a onClick={onPrimaryButtonLinkToClick} className="text-decoration-none">
                                {primaryButtonText}
                            </a>
                        )}

                        
                    </Button>
                    
                    {/* Allows to handle custom functions and simple navigations */}
                    <a
                        href={!Utility.isNullOrUndefinedOrEmpty(onSecondaryButtonLinkTo) ? onSecondaryButtonLinkTo : undefined}
                        onClick={Utility.isNullOrUndefinedOrEmpty(onSecondaryButtonLinkTo) ? onSecondaryButtonLinkClick : undefined}
                        className="text-decoration-none"
                    >
                        <div
                            className="text-light-blue"
                            style={{ fontSize: 14 }}
                        >
                            {secondaryButtonText}
                        </div>
                    </a>
                    
                </div>
            </div>
        </Modal>
    );
};

export default ConfirmationModal;
